"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const utilities_1 = __importStar(require("jsAssets/utilities"));
const qs_1 = __importDefault(require("qs"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const helper_1 = require("../../../reviews/helper");
const selectors_1 = __importDefault(require("../../slice/selectors"));
const sliceReview_1 = require("../../slice/sliceReview");
const constants_1 = require("../../slice/sliceReview/constants");
const store_1 = require("../../store");
const utils_1 = require("../../utils");
const AssetThumbnailTooltip_1 = __importDefault(require("./AssetThumbnailTooltip"));
const Overview_1 = __importDefault(require("./Overview"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
var PulseTabsTheme;
(function (PulseTabsTheme) {
    PulseTabsTheme["dark"] = "dark";
    PulseTabsTheme["light"] = "light";
})(PulseTabsTheme || (PulseTabsTheme = {}));
const URL = helper_1.URLS === null || helper_1.URLS === void 0 ? void 0 : helper_1.URLS.pulse;
const ShareReviewSetting = ({ formikProps }) => {
    const { currentStage, url, round, assetIds, mode, fetchedRound, phase, assetsInfo, historyPhases, title, } = (0, react_redux_1.useSelector)(selectors_1.default);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const [assetThumbnailIds, setAssetThumbnailIds] = (0, react_1.useState)([]);
    const dispatchReviewTitle = (newTitle) => {
        dispatch((0, sliceReview_1.updateReviewTitle)(newTitle));
    };
    (0, react_1.useEffect)(() => {
        if ((mode === constants_1.MODE.update || mode === constants_1.MODE.newRound) && !fetchedRound) {
            dispatch((0, sliceReview_1.fetchRound)(round === null || round === void 0 ? void 0 : round.id));
        }
        // for previous option always fetch round
        if (fetchedRound && currentStage === constants_1.OPTION.previous) {
            dispatch((0, sliceReview_1.fetchRound)(round === null || round === void 0 ? void 0 : round.id));
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (phase === constants_1.PHASE.reviewing) {
            dispatch((0, sliceReview_1.enableNextBtn)());
        }
    }, [historyPhases]);
    (0, react_1.useEffect)(() => {
        if (phase === constants_1.PHASE.reviewing) {
            if (currentStage !== constants_1.OPTION.url || mode !== constants_1.MODE.create) {
                setAssetThumbnailIds(assetIds);
            }
            else {
                dispatchReviewTitle(title || '');
            }
            if (mode === constants_1.MODE.create && currentStage === constants_1.OPTION.url) {
                dispatchReviewTitle(url.urls[0] || '');
            }
        }
    }, [assetIds, url]);
    (0, react_1.useEffect)(() => {
        let assetIdFilters = '';
        assetThumbnailIds.forEach((id) => {
            assetIdFilters = assetIdFilters.concat(`filter[assetid][]=${id}&`);
        });
        if (assetIdFilters) {
            const INCLUDE = 'uploaded-by,requirement.job,requirement.job.client';
            const params = {
                include: INCLUDE,
            };
            const queryParamsString = qs_1.default.stringify(params, {
                encode: false,
            });
            utils_1.v2EndpointCustom
                .get(`${helper_1.URLS === null || helper_1.URLS === void 0 ? void 0 : helper_1.URLS.pulse}v2/api/assets?${assetIdFilters}${queryParamsString}`)
                .then((res) => {
                const { data } = res;
                const assets = (0, utilities_1.parseJsonApi)((0, utilities_1.camelizeKeys)(data));
                dispatch((0, sliceReview_1.updateAssetInfo)(assets));
                if (mode !== constants_1.MODE.update && mode !== constants_1.MODE.newRound) {
                    dispatch((0, sliceReview_1.updateReviewTitle)(assets[0].title));
                }
            });
        }
    }, [assetThumbnailIds]);
    (0, react_1.useEffect)(() => {
        if (mode === constants_1.MODE.share || mode === constants_1.MODE.create) {
            const paramRoundTypes = {
                filter: {
                    name: 'internal',
                },
            };
            const queryParamsRoundTypesString = qs_1.default.stringify(paramRoundTypes, {
                encode: false,
            });
            utils_1.v2EndpointCustom
                .get(`${helper_1.URLS === null || helper_1.URLS === void 0 ? void 0 : helper_1.URLS.pulse}v2/api/round-types?${queryParamsRoundTypesString}`)
                .then((res) => {
                var _a, _b;
                const { data } = res;
                const roundType = (0, utilities_1.parseJsonApi)((0, utilities_1.camelizeKeys)(data));
                if (roundType[0]) {
                    dispatch((0, sliceReview_1.updateCurrentRound)({
                        valueUpdate: {
                            roundType: {
                                value: (_a = roundType[0]) === null || _a === void 0 ? void 0 : _a.id,
                                label: (_b = roundType[0]) === null || _b === void 0 ? void 0 : _b.label,
                            },
                        },
                    }));
                }
            })
                .catch((error) => {
                utilities_1.default.notification.danger(error);
            });
        }
        const paramStageNotify = {
            filter: {
                name: 'disabled',
            },
        };
        const queryParamsStageNotifyString = qs_1.default.stringify(paramStageNotify, { encode: false });
        utils_1.v2EndpointCustom
            .get(`${helper_1.URLS === null || helper_1.URLS === void 0 ? void 0 : helper_1.URLS.pulse}v2/api/stage-notification-types?${queryParamsStageNotifyString}`)
            .then((res) => {
            var _a, _b, _c;
            const { data } = res;
            const stageNotify = (0, utilities_1.parseJsonApi)((0, utilities_1.camelizeKeys)(data));
            if (stageNotify[0]) {
                dispatch((0, sliceReview_1.getDefaultNotify)({
                    id: (_a = stageNotify[0]) === null || _a === void 0 ? void 0 : _a.id,
                    label: (_b = stageNotify[0]) === null || _b === void 0 ? void 0 : _b.label,
                    value: (_c = stageNotify[0]) === null || _c === void 0 ? void 0 : _c.id,
                }));
            }
        })
            .catch((error) => {
            utilities_1.default.notification.danger(error);
        });
        const paramStatusStrategy = {
            filter: {
                name: ['all_decisions', 'primary_decision_maker'],
            },
        };
        const queryParamsStatusStrategyString = qs_1.default.stringify(paramStatusStrategy, {
            encode: false,
        });
        utils_1.v2EndpointCustom
            .get(`${helper_1.URLS === null || helper_1.URLS === void 0 ? void 0 : helper_1.URLS.pulse}v2/api/stage-status-strategies?${queryParamsStatusStrategyString}`)
            .then((res) => {
            const { data } = res;
            const statusStrategy = (0, utilities_1.parseJsonApi)((0, utilities_1.camelizeKeys)(data));
            if (statusStrategy.length) {
                statusStrategy.forEach((status) => {
                    if ((status === null || status === void 0 ? void 0 : status.name) === 'all_decisions') {
                        dispatch((0, sliceReview_1.getDefaultStatusCalculation)((0, helper_1.statusStrategyTransform)(status)));
                    }
                    if ((status === null || status === void 0 ? void 0 : status.name) === 'primary_decision_maker') {
                        dispatch((0, sliceReview_1.setMadeDecisionStatusCalculationId)((0, helper_1.statusStrategyTransform)(status)));
                    }
                });
            }
        })
            .catch((error) => {
            utilities_1.default.notification.danger(error);
        });
    }, []);
    const getLabel = (0, react_1.useMemo)(() => {
        let roundNumber = 1;
        if (phase === constants_1.PHASE.reviewing) {
            if (round === null || round === void 0 ? void 0 : round.round_number) {
                roundNumber =
                    mode === constants_1.MODE.newRound
                        ? (round === null || round === void 0 ? void 0 : round.last_round_number) + 1
                        : round === null || round === void 0 ? void 0 : round.round_number;
            }
        }
        return `REVIEW ROUND ${roundNumber}`;
    }, [phase, mode, round === null || round === void 0 ? void 0 : round.round_number]);
    const contentURLTooltip = (0, react_1.useMemo)(() => (react_1.default.createElement("div", null,
        react_1.default.createElement("span", null, "WEBSITE/URL:"),
        react_1.default.createElement("span", { className: styles_modules_less_1.default['thumbnail-info__tooltip'] }, url.urls[0] || ''))), [url]);
    const assetThumbnail = (0, react_1.useMemo)(() => {
        var _a;
        if (assetThumbnailIds.length > 0 && assetsInfo.length > 0) {
            return (react_1.default.createElement(react_1.default.Fragment, null, assetThumbnailIds.map((assetId) => (react_1.default.createElement(pulse_components_1.PulseTooltip, { key: assetId, TippyProps: {
                    content: (react_1.default.createElement(AssetThumbnailTooltip_1.default, { assetInfo: assetsInfo.find((item) => item.assetId === assetId) })),
                    placement: 'bottom',
                    className: styles_modules_less_1.default['review-setting__tooltip'],
                    popperOptions: {
                        strategy: 'fixed',
                    },
                    offset: [0, -30],
                } }, (0, helper_1.hasPreview)(assetsInfo[0]) ? (react_1.default.createElement("div", { className: styles_modules_less_1.default['review-setting__assets--thumbnail'] },
                react_1.default.createElement("img", { className: styles_modules_less_1.default.assets__thumbnail__img, src: `${URL}open.php?format=thumb&assetid=${assetId}`, alt: assetId === null || assetId === void 0 ? void 0 : assetId.toString() }))) : (react_1.default.createElement("div", { className: styles_modules_less_1.default['review-setting__assets--thumbnail'] },
                react_1.default.createElement("img", { className: styles_modules_less_1.default.assets__thumbnail__img, src: helper_1.processingAsset }))))))));
        }
        if ((0, helper_1.isUrlSourceType)(round, currentStage, url) &&
            assetThumbnailIds.length <= 0) {
            return (react_1.default.createElement(react_1.default.Fragment, null, (_a = url === null || url === void 0 ? void 0 : url.urls) === null || _a === void 0 ? void 0 : _a.map((assetUrl) => {
                return (react_1.default.createElement("div", { key: assetUrl, className: styles_modules_less_1.default['review-setting__assets--thumbnail'] }, (round === null || round === void 0 ? void 0 : round.thumbnailLink) &&
                    (round === null || round === void 0 ? void 0 : round.source) &&
                    (round === null || round === void 0 ? void 0 : round.source[0]) &&
                    (round === null || round === void 0 ? void 0 : round.source[0].url) === assetUrl ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("img", { className: (0, clsx_1.default)(styles_modules_less_1.default.assets__thumbnail__img, styles_modules_less_1.default['thumbnail__img--readyUrl']), src: (round === null || round === void 0 ? void 0 : round.thumbnailLink) || '' }),
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['assets-thumbnail__info'] },
                        react_1.default.createElement("p", { className: styles_modules_less_1.default['thumbnail-info__url'] }, assetUrl),
                        react_1.default.createElement(pulse_components_1.PulseTooltip, { classes: {
                                childrenRoot: styles_modules_less_1.default['asset__url--ctn'],
                            }, TippyProps: {
                                content: contentURLTooltip,
                                placement: 'right',
                            } },
                            react_1.default.createElement("i", { className: "fal fa-info-circle" }))))) : (react_1.default.createElement("div", { className: styles_modules_less_1.default['review-setting__assets--url'], key: assetUrl },
                    react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['asset__url--img'], 'fal fa-browser') })))));
            })));
        }
        return (react_1.default.createElement("div", { className: styles_modules_less_1.default['review-setting__assets--thumbnail'] },
            react_1.default.createElement("img", { className: styles_modules_less_1.default.assets__thumbnail__img, src: helper_1.processingAsset })));
    }, [assetThumbnailIds, currentStage, url, assetsInfo, round === null || round === void 0 ? void 0 : round.thumbnailLink]);
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['review-setting'] },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['review-setting__assets'] },
            react_1.default.createElement("label", { className: styles_modules_less_1.default['review-setting__assets--label'] }, (0, helper_1.isUrlSourceType)(round, currentStage, url)
                ? `Urls for review (${url.urls.length})`
                : `Files for review (${assetThumbnailIds.length})`),
            assetThumbnail),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['review-setting__content'] },
            react_1.default.createElement(pulse_components_1.PulseChip, { PulseTooltipProps: {
                    TippyProps: {
                        visible: false,
                    },
                }, label: getLabel, classes: { root: styles_modules_less_1.default['chip-round'] } }),
            react_1.default.createElement(pulse_components_1.PulseTabs, { classes: {
                    root: styles_modules_less_1.default['tab-root'],
                }, TabsProps: {
                    scrollButtons: 'auto',
                    variant: 'scrollable',
                    classes: {
                        flexContainer: styles_modules_less_1.default['tab-root__flexContainer'],
                    },
                }, tabData: [
                    {
                        id: 'tab01',
                        tabLabel: 'OVERVIEW',
                        tabContent: react_1.default.createElement(Overview_1.default, { formikProps: formikProps }),
                        TabProps: {
                            classes: {
                                selected: styles_modules_less_1.default['tab-root__selected'],
                                disabled: styles_modules_less_1.default['tab-root__disabled'],
                            },
                        },
                    },
                    {
                        id: 'tab02',
                        tabLabel: 'ADVANCED',
                        tabContent: (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", null, "Advanced Content"))),
                        TabProps: {
                            disabled: true,
                            classes: {
                                selected: styles_modules_less_1.default['tab-root__selected'],
                                disabled: styles_modules_less_1.default['tab-root__disabled'],
                            },
                        },
                    },
                ], theme: PulseTabsTheme.light }))));
};
exports.default = ShareReviewSetting;
